/**
 * Maps each route segment to a feature slug used by the backend access table.
 * Keep in sync with `BASIC_CORE_FEATURES` and add-on slugs in server.py.
 */
export const ROUTE_TO_FEATURE = {
  "": "dashboard",
  "properties": "properties",
  "portfolio": "portfolio",
  "guide": "guide",
  "referrals": "referrals",
  "property-history": "property-history",
  "rent-comps": "rent-comps",
  "news": "news",
  "loans": "loan-rebalancer",
  "tenants": "tenants",
  "projects": "projects",
  "will": "will",
  "compare": "compare",
  "calculators": "calculators",
  "advisor": "advisor",
  "admin": "admin",
};

export const FEATURE_LABELS = {
  "calculators": "Financial Calculators",
  "compare": "Side-by-side Compare",
  "advisor": "AI Advisor",
  "loan-rebalancer": "Loan Rebalancer",
  "rent-comps": "Rent Comps",
  "news": "Real-Estate News",
  "tenants": "Tenants & Rental Mgmt",
  "projects": "Projects Tracker",
  "will": "AI Will Drafting",
  "property-history": "Property Transaction History",
};

export function isFeatureUnlocked(access, slug) {
  if (!access) return true; // pre-load: don't flash a lock
  if (access.unlocked_features === "*") return true;
  if (!Array.isArray(access.unlocked_features)) return false;
  return access.unlocked_features.includes(slug);
}
